export enum OneSignalEventName {
  PLAN_PAGE_VIEW = "plan_page_view",
  BEGIN_CHECKOUT = "begin_checkout",
  PURCHASE = "purchase",
  PURCHASE_FAIL = "purchase_fail",
  UPSALE_PAGE_VIEW = "upsale_page_view",
}

export interface OneSignalReportEventRequestDto {
  cid: string;
  event_name: OneSignalEventName;
  page_url: string;
  product_id?: string;
  upsell_number?: string;
}

const removeEmptyOptionalFields = (
  payload: OneSignalReportEventRequestDto
): OneSignalReportEventRequestDto => {
  const { product_id, upsell_number, ...requiredFields } = payload;

  return {
    ...requiredFields,
    ...(product_id ? { product_id } : {}),
    ...(upsell_number ? { upsell_number } : {}),
  };
};

export const reportOneSignalEvent = async (
  apiEndpoint: string,
  payload: OneSignalReportEventRequestDto
): Promise<Response> => {
  if (!apiEndpoint?.trim()) {
    throw new Error("OneSignal event requires an API endpoint");
  }

  if (!payload.cid?.trim()) {
    throw new Error("OneSignal event requires a non-empty cid");
  }

  if (!Object.values(OneSignalEventName).includes(payload.event_name)) {
    throw new Error(`Unsupported OneSignal event name: ${payload.event_name}`);
  }

  if (!payload.page_url?.trim()) {
    throw new Error("OneSignal event requires a non-empty page_url");
  }

  const response = await fetch(
    `${apiEndpoint.replace(/\/$/, "")}/onesignal/event`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(removeEmptyOptionalFields(payload)),
    }
  );

  if (!response.ok) {
    throw new Error(
      `OneSignal event request failed: ${response.status} ${response.statusText}`
    );
  }

  return response;
};
